import React, { useEffect } from "react";
import { oneOfType, string, func, bool, array } from "prop-types";
import { connect } from "react-redux";
import { push } from "connected-react-router";

import { actions as loansActions, selectors as loansSelectors } from "reducers/loans";
import { actions as menuActions } from "reducers/drawer";

import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import Button from "pages/_components/Button";
import { isIOS } from "react-device-detect";
import CustomProductHead from "pages/_components/CustomProductHead";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import Options from "pages/_components/Options";
import Action from "pages/loans/_components/Action";
import ActiveLoans from "./_components/ActiveLoans";
import HistoricalLoans from "./_components/HistoricalLoans";

const Loans = (props) => {
    const { fetching, isDesktop, dispatch, activeLoans, historicalLoans } = props;
    const isLoading = fetching && !activeLoans.length && !historicalLoans.length;

    useEffect(() => {
        dispatch(loansActions.listLoansV2());
        dispatch(loansActions.clearFilters());
    }, []);

    const renderHeader = () => {
        const renderMenuOption = () => (
            <>
                {isDesktop ? (
                    <>
                        <div className="toolbar-item add-button" key="add">
                            <CustomButton
                                func={() => dispatch(push("/applyForLoan"))}
                                className="btn btn-primary btn-block"
                                icon={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/nuevo.svg"}
                                text="loans.list.button.apply"
                                textType="I18N"
                            />
                        </div>
                    </>
                ) : (
                    <div className="toolbar-item commands-mobile">
                        <Button
                            className="toolbar-btn view-options"
                            onClick={() => dispatch(menuActions.menuShow())}
                            image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-mobile.svg"}
                            label="view more options"
                            block={false}
                            bsStyle="link"
                        />
                    </div>
                )}
                {!isDesktop && (
                    <Options>
                        <Action isDesktop={isDesktop} labelKey="loans.list.button.apply" to="applyForLoan" />
                    </Options>
                )}
            </>
        );
        return (
            <CustomProductHead
                titleId="loans.productType.loans"
                backLinkTo="/desktop"
                addLinkToLabel="deposits.new"
                addLinkTo="/applyForLoan"
                className="deposits"
                renderMenuOption={renderMenuOption}>
                <div className="toolbar-item view-title">
                    <ViewTitle id="loans.productType.loans" />
                </div>
            </CustomProductHead>
        );
    };

    const renderTabs = () => {
        const tabsData = [
            {
                text: "loans.list.tab.currentLoans.title",
                textType: "I18N",
            },
            {
                text: "loans.list.tab.historicalLoans.title",
                textType: "I18N",
            },
        ];

        return (
            <MainContainer showLoader={fetching}>
                <CustomTabs tabsData={tabsData} defaultTab={0}>
                    <ActiveLoans isDesktop={isDesktop} isLoading={isLoading} activeLoans={activeLoans} />
                    <HistoricalLoans isDesktop={isDesktop} isLoading={isLoading} historicalLoans={historicalLoans} />
                </CustomTabs>
            </MainContainer>
        );
    };

    return (
        <>
            <Notification scopeToShow="loans" />
            {!fetching && renderHeader()}
            {renderTabs()}
        </>
    );
};

Loans.propTypes = {
    dispatch: func.isRequired,
    isDesktop: oneOfType([string, bool]),
    fetching: oneOfType([string, bool]),
    activeLoans: oneOfType([array]).isRequired,
    historicalLoans: oneOfType([array]).isRequired,
};

Loans.defaultProps = {
    isDesktop: false,
    fetching: false,
};

const mapStateToProps = (state) => ({
    fetching: loansSelectors.getFetching(state),
    activeLoans: loansSelectors.getActiveLoans(state),
    historicalLoans: loansSelectors.getHistoricalLoans(state),
});

export default connect(mapStateToProps)(Loans);
